import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface XLogoIconProps extends SvgIconProps {}

export const XLogoIcon = (props: XLogoIconProps): ReactElement => {
  return (
    <SvgIcon style={{ fontSize: '1em' }} {...props} viewBox="0 0 25 25">
      <g clipPath="url(#clip0_477_6158)">
        <path
          d="M15.4735 11.4334L25.1526 0.000732422H22.859L14.4546 9.92755L7.74211 0.000732422H0L10.1507 15.0118L0 27.0007H2.29376L11.169 16.5176L18.2579 27.0007H26L15.4735 11.4334ZM12.3319 15.1441L11.3034 13.6493L3.12024 1.7553H6.64332L13.2473 11.3541L14.2757 12.8489L22.8601 25.3259H19.337L12.3319 15.1441Z"
          fill="black"
        />
        <path
          d="M15.4735 11.4334L25.1526 0.000732422H22.859L14.4546 9.92755L7.74211 0.000732422H0L10.1507 15.0118L0 27.0007H2.29376L11.169 16.5176L18.2579 27.0007H26L15.4735 11.4334ZM12.3319 15.1441L11.3034 13.6493L3.12024 1.7553H6.64332L13.2473 11.3541L14.2757 12.8489L22.8601 25.3259H19.337L12.3319 15.1441Z"
          fill="black"
          fillOpacity="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_477_6158">
          <rect
            width="26"
            height="27"
            fill="white"
            transform="translate(0 0.000732422)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
